import { createReducer } from "redux-act";

import {
  REQPushNotiList,
  RESPushNotiList,
  FailPushNotiList,
  CleanUpPushNotiList
} from "./actions";

const initialState = {
  REQStrPushNotiList: false,
  PushNotiList: [],
  RemoteAvailable: false,
  errorMessage: false
};

const pushNotiListReducer = createReducer(
  {
    [REQPushNotiList]: state => {
      return {
        ...state,
        REQStrPushNotiList: true
      };
    },

    [RESPushNotiList]: (state, payload) => {
      return {
        ...state,
        REQStrPushNotiList: false,
        PushNotiList: payload.campaigns,
        RemoteAvailable: payload.remoteAvailable,
        errorMessage: false
      };
    },

    [FailPushNotiList]: (state, payload) => {
      return {
        ...state,
        REQStrPushNotiList: false,
        errorMessage: (payload && payload.message) || "โหลดรายการไม่สำเร็จ"
      };
    },

    [CleanUpPushNotiList]: () => {
      return initialState;
    }
  },

  initialState
);

export default pushNotiListReducer;
